export default __webpack_public_path__ + "static/media/Magnetism_00.2eaecd8c.png";